import React from "react";
import { Link } from "react-router-dom";
import { MenuData, FooterMenuData } from "../json/menu";

export class GlobalNav extends React.Component {
  constructor(props) {
    super(props);
    this.toggleMobile = this.toggleMobile.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
  }

  toggleMobile() {
    this.menu.classList.toggle("active");
  }

  hideMenu() {
    this.menu.classList.remove("active");
  }
  render() {
    const nav = MenuData.map(item => (
      <NavItem key={item.id} data={item} clickHandler={this.hideMenu} />
    ));
    return (
      <nav className="globalNav flex" ref={menu => (this.menu = menu)}>
        <ul className="flex">{nav}</ul>
        {window.isMobile === true && (
          <div className="mobileMenu" onClick={this.toggleMobile}>
            <p className="text uppercase margin-right-small">Menu</p>
            <div className="icon" />
          </div>
        )}
      </nav>
    );
  }
}

class NavItem extends React.Component {
  render() {
    const item = this.props.data;

    return (
      <li
        className={`menu-item ${item.id}`}
        onClick={
          typeof this.props.clickHandler !== "undefined"
            ? this.props.clickHandler
            : null
        }
      >
        <Link
          to={item.url}
          data-section={item.text}
          data-subsection={item.text}
          data-pagetype="Collection"
        >
          {item.text}
        </Link>
      </li>
    );
  }
}

export class FooterNav extends React.Component {
  render() {
    const nav = FooterMenuData.map(item => (
      <NavItem key={item.id} data={item} />
    ));
    return <nav className="footerNav margin-top-large flex">{nav}</nav>;
  }
}



// WEBPACK FOOTER //
// ./src/nav/Nav.js